import React from "react";

// Mirrors the backend's constants/currencies.ts - keep in sync if that list changes.
export const CURRENCY_SYMBOLS = { PHP: "₱", USD: "$", INR: "₹", EUR: "€", GBP: "£", AUD: "A$", SGD: "S$", JPY: "¥", CNY: "¥", CAD: "C$" };
export const CURRENCY_OPTIONS = Object.entries(CURRENCY_SYMBOLS).map(([code, symbol]) => ({ value: code, label: `${code} (${symbol})` }));

const COLORS = ["#4F46E5", "#14B8A6", "#F59E0B", "#8B5CF6", "#EC4899", "#3B82F6", "#10B981", "#6B7280"];

export const initials = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join("") || "?";

export const avatarColor = (name = "") => {
  let h = 0;
  for (const ch of name) h = (h * 31 + ch.charCodeAt(0)) % 997;
  return COLORS[h % COLORS.length];
};

// Round initials badge used in the list and on the profile.
export const Avatar = ({ name, size = 38 }) => (
  <div
    style={{
      width: size,
      height: size,
      borderRadius: "50%",
      background: avatarColor(name),
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      fontSize: Math.round(size * 0.36),
      flex: "none",
    }}
  >
    {initials(name)}
  </div>
);

export const formatMoney = (amount, currency = "PHP") => `${CURRENCY_SYMBOLS[currency] || ""}${Number(amount || 0).toLocaleString()} ${currency}`;

// One "label: value" cell of a details card.
export const Field = ({ label, children }) => (
  <div>
    <div style={{ color: "#6B7280", fontSize: 12, marginBottom: 3 }}>{label}</div>
    <div style={{ fontWeight: 500, minHeight: 20 }}>{children || <span style={{ color: "#9CA3AF" }}>Not set</span>}</div>
  </div>
);

// A titled card used on the profile and the form.
export const Section = ({ id, title, hint, children }) => (
  <div id={id} className="i-ems-card" style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 14, padding: "18px 20px", scrollMarginTop: 16 }}>
    <div style={{ display: "flex", alignItems: "baseline", marginBottom: 14 }}>
      <h3 style={{ fontSize: 15, margin: 0 }}>{title}</h3>
      {hint ? <span style={{ marginLeft: "auto", color: "#6B7280", fontSize: 12 }}>{hint}</span> : null}
    </div>
    {children}
  </div>
);
